import redpayLogo from "../assets/redpay_logo.jpg";
const BRANDING = {
    appName: "RedPay SMS Platform",

    shortName: "RedPay",

    portalTitle: "RedPay SMS Platform",

    portalSubtitle:
        "Messaging & Customer Communication Platform",

    primaryColor: "#D71920",

    secondaryColor: "#2B2B2B",

    logo: redpayLogo,

    favicon: "/favicon.ico",
};

export default BRANDING;